var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.473,
    height: 56.21,
    viewBox: "0 0 68.473 56.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34357",
    "data-name": "Group 34357",
    transform: "translate(18138.076 14301.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33544",
    "data-name": "Group 33544",
    transform: "translate(-18136.977 -14300.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33546",
    "data-name": "Group 33546",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_546",
    "data-name": "Ellipse 546",
    cx: 7.431,
    cy: 7.431,
    r: 7.431,
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33544-2",
    "data-name": "Group 33544",
    transform: "translate(4.081 4.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27291",
    "data-name": "Path 27291",
    d: "M6319.278,2394.76l2.558,2.281,4.141-5.064",
    transform: "translate(-6319.278 -2391.977)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33545",
    "data-name": "Group 33545",
    transform: "translate(38.644 10.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27292",
    "data-name": "Path 27292",
    d: "M6367.7,2442.106v-.005a3.361,3.361,0,0,0-2.073-3.119,11.079,11.079,0,0,1-6.049-6.512,21.927,21.927,0,0,0-1.824-3.666c-.723-1.14-1.883-2.625-2.77-3.97-.99-1.505-1.1-2.439-.005-3.4a.693.693,0,0,0,.068-.056,2.125,2.125,0,0,1,3.053.366,26.579,26.579,0,0,0,5.692,5.909,1.447,1.447,0,0,0,2.3-1.16v-.026",
    transform: "translate(-6354.202 -2415.922)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27293",
    "data-name": "Path 27293",
    d: "M6381.816,2409.36c2.564.7,5.3,1.743,6.878,3.236,2.193,2.07,2.518,7.251,3.236,10.415a45.1,45.1,0,0,1,1.51,12.15v5.62",
    transform: "translate(-6369.922 -2409.36)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    y2: 5.242,
    transform: "translate(52.146 37.119)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27294",
    "data-name": "Path 27294",
    d: "M6394.611,2493.958v-10.327a1.322,1.322,0,0,0-1.322-1.322h-15.316a1.323,1.323,0,0,0-1.323,1.322v10.327",
    transform: "translate(-6328.337 -2439.948)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27295",
    "data-name": "Path 27295",
    d: "M6325.158,2421.108V2433.4h33.911",
    transform: "translate(-6317.728 -2402.207)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27296",
    "data-name": "Path 27296",
    d: "M6379.78,2402.036V2388.1h-31.591",
    transform: "translate(-6329.243 -2380.556)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_88455",
    "data-name": "Rectangle 88455",
    transform: "translate(-18118.92 -14289.351)",
    fill: "none",
    stroke: "#f37f25",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.676,
    height: 10.845,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 1.1,
    width: 6.476,
    height: 8.645,
    rx: 0.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    x2: 16.628,
    transform: "translate(-18117.834 -14275.253)",
    fill: "none",
    stroke: "#f37f25",
    strokeLinecap: "round",
    strokeWidth: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6);
export default __webpack_public_path__ + "static/media/step6.9c6aa44e8572e28b68b264dfcd4a46ac.svg";
export { ForwardRef as ReactComponent };